import React from 'react';

import { NotificationTypes } from '../../store/types/types';
import { StyledAlert } from './notification.styles';


const Notification = ({ alert, status }: NotificationTypes) => {
    const label = `${alert}-${status}`;

    if (status === 'success') {
        return (
            <StyledAlert aria-label={label} severity={status}>
                <strong>{alert.toUpperCase()}</strong> request has been successful.
            </StyledAlert>
        )
    }

    if (status === 'error') {
        return (
            <StyledAlert aria-label={label} severity={status}>
                <strong>{alert.toUpperCase()}</strong> request has not been successful. Please try again in a few minutes...
            </StyledAlert>
        )
    }

    if (status === 'warning') {
        return (
            <StyledAlert aria-label={label} severity={status}>
                <strong>**{alert.toUpperCase()}**</strong> This request has already been {alert}.
            </StyledAlert>
        )
    }

    return null;
};

export default Notification;
